var moduleMap = {
	"./assistPanelModule": function() {
		return Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators-webpack_sharing_consume-585cd6"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core-_c37a"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core-_bdc1"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-src_app_assist-panel_assist-panel_module_ts"), __webpack_require__.e("default-node_modules_savvaslearning_cel-components_dist-stencil_loader_index_es2017_js-src_ap-f3e34c")]).then(function() { return function() { return (__webpack_require__(/*! ./src/app/assist-panel/assist-panel.module.ts */ 54565)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});